import { CORE_CARS_NAME, CoreCarsComponent } from "@apac/cars";

// Cars Overrides
import carAvailabilityFilterRowStyles from "./cars/styles/CarAvailabilityFilterRow.module.scss";
import carListNoResultStyles from "./cars/styles/CarListNoResult.module.scss";
import carReservationCardStyles from "./cars/styles/CarReservationCard.module.scss";
import carListSortStyles from "./cars/styles/CarsListSort.module.scss";
import carSpecificationsSummaryStyles from "./cars/styles/CarSpecificationsSummary.module.scss";
import carPaymentSummaryLineItemStyles from "./cars/styles/PaymentSummaryLineItem.module.scss";

export const carsStyleOverrides = {
  [CORE_CARS_NAME]: {
    [CoreCarsComponent.CarAvailabilityFilterRow]:
      carAvailabilityFilterRowStyles,
    [CoreCarsComponent.CarListNoResult]: carListNoResultStyles,
    [CoreCarsComponent.CarListSort]: carListSortStyles,
    [CoreCarsComponent.CarReservationCard]: carReservationCardStyles,
    [CoreCarsComponent.PaymentSummaryLineItem]: carPaymentSummaryLineItemStyles,
    [CoreCarsComponent.CarSpecificationsSummary]:
      carSpecificationsSummaryStyles,
  },
};
